import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

// Whitelist of allowed icon names for security
const ALLOWED_ICONS = [
  'FiActivity', 'FiAirplay', 'FiAlertCircle', 'FiAlertOctagon', 'FiAlertTriangle',
  'FiAlignCenter', 'FiAlignJustify', 'FiAlignLeft', 'FiAlignRight', 'FiAnchor',
  'FiAperture', 'FiArchive', 'FiArrowDown', 'FiArrowDownCircle', 'FiArrowDownLeft',
  'FiArrowDownRight', 'FiArrowLeft', 'FiArrowLeftCircle', 'FiArrowRight', 
  'FiArrowRightCircle', 'FiArrowUp', 'FiArrowUpCircle', 'FiArrowUpLeft', 
  'FiArrowUpRight', 'FiAtSign', 'FiAward', 'FiBarChart', 'FiBarChart2', 
  'FiBattery', 'FiBatteryCharging', 'FiBell', 'FiBellOff', 'FiBluetooth', 
  'FiBold', 'FiBook', 'FiBookmark', 'FiBookOpen', 'FiBox', 'FiBriefcase', 
  'FiCalendar', 'FiCamera', 'FiCameraOff', 'FiCast', 'FiCheck', 'FiCheckCircle', 
  'FiCheckSquare', 'FiChevronDown', 'FiChevronLeft', 'FiChevronRight', 
  'FiChevronsDown', 'FiChevronsLeft', 'FiChevronsRight', 'FiChevronsUp', 
  'FiChevronUp', 'FiChrome', 'FiCircle', 'FiClipboard', 'FiClock', 'FiCloud', 
  'FiCloudDrizzle', 'FiCloudLightning', 'FiCloudOff', 'FiCloudRain', 
  'FiCloudSnow', 'FiCode', 'FiCodepen', 'FiCodesandbox', 'FiCoffee', 'FiColumns', 
  'FiCommand', 'FiCompass', 'FiCopy', 'FiCornerDownLeft', 'FiCornerDownRight', 
  'FiCornerLeftDown', 'FiCornerLeftUp', 'FiCornerRightDown', 'FiCornerRightUp', 
  'FiCornerUpLeft', 'FiCornerUpRight', 'FiCpu', 'FiCreditCard', 'FiCrop', 
  'FiCrosshair', 'FiDatabase', 'FiDelete', 'FiDisc', 'FiDollarSign', 'FiDownload', 
  'FiDownloadCloud', 'FiDroplet', 'FiEdit', 'FiEdit2', 'FiEdit3', 'FiExternalLink', 
  'FiEye', 'FiEyeOff', 'FiFacebook', 'FiFastForward', 'FiFeather', 'FiFigma', 
  'FiFile', 'FiFileMinus', 'FiFilePlus', 'FiFileText', 'FiFilm', 'FiFilter', 
  'FiFlag', 'FiFolder', 'FiFolderMinus', 'FiFolderPlus', 'FiFrown', 'FiGift', 
  'FiGitBranch', 'FiGitCommit', 'FiGitMerge', 'FiGitPullRequest', 'FiGithub', 
  'FiGitlab', 'FiGlobe', 'FiGrid', 'FiHardDrive', 'FiHash', 'FiHeadphones', 
  'FiHeart', 'FiHelpCircle', 'FiHexagon', 'FiHome', 'FiImage', 'FiInbox', 
  'FiInfo', 'FiInstagram', 'FiItalic', 'FiKey', 'FiLayers', 'FiLayout', 
  'FiLifeBuoy', 'FiLink', 'FiLink2', 'FiLinkedin', 'FiList', 'FiLoader', 
  'FiLock', 'FiLogIn', 'FiLogOut', 'FiMail', 'FiMap', 'FiMapPin', 'FiMaximize', 
  'FiMaximize2', 'FiMeh', 'FiMenu', 'FiMessageCircle', 'FiMessageSquare', 
  'FiMic', 'FiMicOff', 'FiMinimize', 'FiMinimize2', 'FiMinus', 'FiMinusCircle', 
  'FiMinusSquare', 'FiMonitor', 'FiMoon', 'FiMoreHorizontal', 'FiMoreVertical', 
  'FiMousePointer', 'FiMove', 'FiMusic', 'FiNavigation', 'FiNavigation2', 
  'FiOctagon', 'FiPackage', 'FiPaperclip', 'FiPause', 'FiPauseCircle', 
  'FiPenTool', 'FiPercent', 'FiPhone', 'FiPhoneCall', 'FiPhoneForwarded', 
  'FiPhoneIncoming', 'FiPhoneMissed', 'FiPhoneOff', 'FiPhoneOutgoing', 
  'FiPieChart', 'FiPlay', 'FiPlayCircle', 'FiPlus', 'FiPlusCircle', 'FiPlusSquare', 
  'FiPocket', 'FiPower', 'FiPrinter', 'FiRadio', 'FiRefreshCcw', 'FiRefreshCw', 
  'FiRepeat', 'FiRewind', 'FiRotateCcw', 'FiRotateCw', 'FiRss', 'FiSave', 
  'FiScissors', 'FiSearch', 'FiSend', 'FiServer', 'FiSettings', 'FiShare', 
  'FiShare2', 'FiShield', 'FiShieldOff', 'FiShoppingBag', 'FiShoppingCart', 
  'FiShuffle', 'FiSidebar', 'FiSkipBack', 'FiSkipForward', 'FiSlack', 
  'FiSlash', 'FiSliders', 'FiSmartphone', 'FiSmile', 'FiSpeaker', 'FiSquare', 
  'FiStar', 'FiStopCircle', 'FiSun', 'FiSunrise', 'FiSunset', 'FiTablet', 
  'FiTag', 'FiTarget', 'FiTerminal', 'FiThermometer', 'FiThumbsDown', 
  'FiThumbsUp', 'FiToggleLeft', 'FiToggleRight', 'FiTool', 'FiTrash', 
  'FiTrash2', 'FiTrello', 'FiTrendingDown', 'FiTrendingUp', 'FiTriangle', 
  'FiTruck', 'FiTv', 'FiTwitch', 'FiTwitter', 'FiType', 'FiUmbrella', 
  'FiUnderline', 'FiUnlock', 'FiUpload', 'FiUploadCloud', 'FiUser', 
  'FiUserCheck', 'FiUserMinus', 'FiUserPlus', 'FiUsers', 'FiUserX', 
  'FiVideo', 'FiVideoOff', 'FiVoicemail', 'FiVolume', 'FiVolume1', 
  'FiVolume2', 'FiVolumeX', 'FiWatch', 'FiWifi', 'FiWifiOff', 'FiWind', 
  'FiX', 'FiXCircle', 'FiXOctagon', 'FiXSquare', 'FiYoutube', 'FiZap', 
  'FiZapOff', 'FiZoomIn', 'FiZoomOut'
];

const isValidIconName = (name) => {
  return typeof name === 'string' && 
         name.startsWith('Fi') && 
         ALLOWED_ICONS.includes(name);
};

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    // If icon is directly provided as a component, use it
    if (icon) {
      IconComponent = icon;
    } 
    // If name is provided, validate it and get the component
    else if (name && isValidIconName(`Fi${name}`)) {
      IconComponent = FiIcons[`Fi${name}`];
    }
    // If neither valid icon nor valid name, fallback to alert triangle
    else {
      IconComponent = FiAlertTriangle;
    }
  } catch (e) {
    // Any error in loading the icon falls back to alert triangle
    IconComponent = FiAlertTriangle;
  }

  // Additional safety check to ensure we have a valid component
  if (!IconComponent || typeof IconComponent !== 'function') {
    IconComponent = FiAlertTriangle;
  }

  return React.createElement(IconComponent, props);
};

export default SafeIcon;